export default "__VITE_ASSET__UkgwfQLb__"